<div class="card-text" style="position: relative; min-width: 500px;">
    <div echarts id="heatmap-chart" [options]="heatmapOptions" (chartClick)="onChartClick($event)" class="demo-chart" style="height: 300px;"></div>
</div>
